export default class MathUtil {
    static randomFloatBetween(min, max) {
        return (Math.random() * (max - min)) + min;
    }
    static randomIntBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    static distance2DBetween(x1, y1, x2, y2) {
        const a = Math.abs(x1 - x2);
        const b = Math.abs(y1 - y2);
        return Math.sqrt(a * a + b * b);
    }
    static distance3DBetween(x1, y1, z1, x2, y2, z2) {
        const a = Math.abs(x1 - x2);
        const b = Math.abs(y1 - y2);
        const c = Math.abs(z1 - z2);
        return Math.sqrt(a * a + b * b + c * c);
    }
    static sum(numbers) {
        let sum = 0;
        numbers.forEach(n => sum += n);
        return sum;
    }
    static average(numbers) {
        return MathUtil.sum(numbers) / numbers.length;
    }
    static safeMin(a, b) {
        const x = isNaN(a) ? Infinity : a;
        const y = isNaN(b) ? Infinity : b;
        const minVal = Math.min(x, y);
        return minVal === Infinity ? NaN : minVal;
    }
    static safeMax(a, b) {
        const x = isNaN(a) ? -Infinity : a;
        const y = isNaN(b) ? -Infinity : b;
        const maxVal = Math.max(x, y);
        return maxVal === -Infinity ? NaN : maxVal;
    }
}
